import * as React from "react";
import styles from "./contactform.module.scss";
import dayjs from "dayjs";
import { OrderInfo } from "./types";
import { ContactSourceType } from "./ContactForm";
import { DeliveryStatus, DeliveryStatusTitle } from "./OrderStatusDisplay";
import {
    ExpansionPanel,
    ExpansionPanelContent,
} from "@progress/kendo-react-layout";

export const OrderInfoUI: React.FC<{
    OrderInfo: OrderInfo;
    SourceType: ContactSourceType;
}> = (props) => {
    const [expanded, setExpanded] = React.useState(false);

    const currentStatus =
        props.OrderInfo.OrderStatusInfo[props.OrderInfo.OrderStatusInfo.length - 1];

    return (
        <div className={styles.orderForm}>
            {props.SourceType === ContactSourceType.Vendor && (
                <>
                    <div className={styles.orderNumberContainer}>
                        Order #<span>{props.OrderInfo.OrderNumber}</span>
                    </div>
                    Vendor Contact Form
                </>
            )}
            {props.SourceType === ContactSourceType.Customer && (
                <>
                <div className={styles.customerInfo}>
                    <div className={styles.orderNumberContainer}>
                        <h2 className={styles.orderNumber}>Order #{props.OrderInfo.OrderNumber}</h2>
                    </div>
                    <p className={styles.emailContainer}>{props.OrderInfo.Email}</p>
                </div>
                    <span>
                        {DeliveryStatusTitle(currentStatus.ChangeType)} on{" "}
                        {dayjs(currentStatus.ChangeDate).format("dddd, M/D h:mm a")}
                    </span>
                    <ExpansionPanel
                        title={"Order History"}
                        subtitle="Expand to view detailed Order History"
                        expanded={expanded}
                        onAction={() => {
                            setExpanded(!expanded);
                        }}
                    >
                        {expanded && (
                            <ExpansionPanelContent>
                                <div className={styles.messages}>
                                    {props.OrderInfo.OrderStatusInfo.map((statusInfo) => {
                                        const dayVal = dayjs(statusInfo.ChangeDate);
                                        const timeKey = statusInfo.ChangeDate.toString();
                                        return (
                                            <div className={styles.history__container} key={timeKey}>
                                                <div className={styles.timeStamp}>
                                                    {dayVal.format("ddd, M/D/YYYY h:mm a")}
                                                </div>
                                                <div className={styles.orderStatus}>
                                                    <DeliveryStatus
                                                        StatusInfo={statusInfo}
                                                    ></DeliveryStatus>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </ExpansionPanelContent>
                        )}
                    </ExpansionPanel>
                </>
            )}
        </div>
    );
};
